import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import CostElement from "../../models/CostElement";
import { DataTable, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { BomCostingService } from "../../service/BomCostingService";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import WorkCenter from "../../models/WorkCenter";
import { Link } from "react-router-dom";

export default function CostElementView() {
    let emptyCE: CostElement = {
        id: 0,
        description: '',
        allowFixedCost: false,
        allowFormulaCost: false,
        workCenterId: 0,
        isUsed: false
    };

    const [listValuesCE, setListValuesCE] = useState<CostElement[]>([]);
    const [singleValueCE, setSingleValueCE] = useState<CostElement>(emptyCE);
    const [loadingCE, setLoadingCE] = useState(true);
    const [globalFilterCE, setGlobalFilterCE] = useState('');
    const [workCenters, setWorkCenters] = useState<WorkCenter[]>([]);
    const isNewCE = useRef(false);
    const formCE = useForm();
    const formEditCE = useForm({ mode: "onChange" });
    const [editingRowsCE, setEditingRowsCE] = useState({});
    const errorsCE = formCE.formState.errors;
    const toastCE = useRef<any>(null);
    const [deleteDialogCE, setDeleteDialogCE] = useState(false);
    const itDescription = useRef<any>(null);
    const chkAllowFixedCost = useRef<any>(null);
    const chkAllowFormulaCost = useRef<any>(null);

    useEffect(() => {
        BomCostingService.getAllCostElements().then(data => {
            setListValuesCE(data);
            setLoadingCE(false);
        });
        BomCostingService.getAllWorkCenters().then((data: WorkCenter[]) => {
            setWorkCenters(data);
        });
    }, []);



    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-end md:align-items-center">
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" onInput={(e) => setGlobalFilterCE((e.target as HTMLInputElement).value)} placeholder="Search..." />
            </IconField>
        </div>
    );

    const NameBodyTemplate = (rowData: CostElement) => {
        return rowData.description.toUpperCase();
    }

    const FixedCostBodyTemplate = (rowData: CostElement) => {
        if (rowData.allowFixedCost) {
            return (
                <React.Fragment>
                    <i className="pi pi-check text-green-500"></i>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <i className="pi pi-times text-red-500"></i>
                </React.Fragment>
            );
        }
    }

    const FormulaCostBodyTemplate = (rowData: CostElement) => {
        if (rowData.allowFormulaCost) {
            return (
                <React.Fragment>
                    <i className="pi pi-check text-green-500"></i>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <i className="pi pi-times text-red-500"></i>
                </React.Fragment>
            );
        }
    }

    const WorkCenterIdBodyTemplate = (rowData: CostElement) => {
        const workCenter = workCenters.find(wc => wc.id === rowData.workCenterId)?.code;
        return workCenter;
    }

    const clearNew = () => {
        formCE.reset();
    }

    const getErrorMessage = (name: string) => {
        return errorsCE[name] ? <small className="p-error">{(errorsCE[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNewCE.current = true;
        let _value = { ...singleValueCE };
        _value.description = data.description;
        _value.allowFixedCost = data.allowFixedCost;
        _value.allowFormulaCost = data.allowFormulaCost;
        _value.workCenterId = data.workCenterId;
        save(_value);
        formCE.reset();
    };

    const save = (value: CostElement) => {
        let _listValues = [...listValuesCE];

        if (isNewCE.current) {
            BomCostingService.addCostElement(value).then((data) => {
                if (data) {
                    _listValues.push(data);
                    setListValuesCE(_listValues);
                    toastCE.current.show({ severity: 'success', summary: 'Successful', detail: 'Cost Element Created', life: 3000 });
                    setSingleValueCE(emptyCE);
                } else {
                    toastCE.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Cost Element', life: 3000 });
                }
            });
        } else {
            BomCostingService.updateCostElement(value).then((data) => {
                if (data) {
                    let index = _listValues.findIndex(v => v.id === value.id);
                    _listValues[index] = value;
                    setListValuesCE(_listValues);
                    toastCE.current.show({ severity: 'success', summary: 'Successful', detail: 'Cost Element Updated', life: 3000 });
                    setSingleValueCE(emptyCE);
                } else {
                    toastCE.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Cost Element', life: 3000 });
                }
            });
        }
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<CostElement[]>) => {
        let selectedIndex = listValuesCE.findIndex(v => v.id === (rowData.value as CostElement).id);
        let _editingRows = { ...editingRowsCE, ...{ [`${listValuesCE[selectedIndex].id}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRowsCE(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRowsCE(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValuesCE];
        let { newData } = e;
        let index = listValuesCE.findIndex(v => v.id === newData.id);
        _listValues[index] = newData;

        setListValuesCE(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'description':
                return descriptionEditor(options);

            case 'allowFixedCost':
                return allowFixedCostEditor(options);

            case 'allowFormulaCost':
                return allowFormulaCostEditor(options);

            case 'workCenterId':
                return workCenterIdEditor(options);
        }
    }

    const descriptionEditor = (options: any) => {
        return (
            <Controller
                name="descriptionEdit"
                control={formEditCE.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    validate: {
                        unique: v => listValuesCE.filter(val => val.description.toLowerCase() === v.toLowerCase()).length === 0 || 'Description must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValueCE.description = field.value;

                    return (
                        <>
                            <InputText ref={itDescription} value={fieldState.isDirty ? field.value.toUpperCase() : options.value.toUpperCase()} maxLength={50} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValueCE.description = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const allowFixedCostEditor = (options: any) => {
        return (
            <Controller
                name="allowFixedCostEdit"
                control={formEditCE.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValueCE.allowFixedCost = field.value;

                    return (
                        <React.Fragment>
                            <Checkbox ref={chkAllowFixedCost} inputId={field.name} checked={fieldState.isDirty ? field.value : options.value} inputRef={field.ref} className={classNames({ 'p-invalid mr-1': fieldState.error })} onChange={(e) => { singleValueCE.allowFixedCost = e.target.value; field.onChange(e.checked) }} />
                        </React.Fragment>
                    )
                }
                }
            />
        );
    }

    const allowFormulaCostEditor = (options: any) => {
        return (
            <Controller
                name="allowFormulaCostEdit"
                control={formEditCE.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValueCE.allowFormulaCost = field.value;

                    return (
                        <React.Fragment>
                            <Checkbox ref={chkAllowFormulaCost} inputId={field.name} checked={fieldState.isDirty ? field.value : options.value} inputRef={field.ref} className={classNames({ 'p-invalid mr-1': fieldState.error })} onChange={(e) => { singleValueCE.allowFormulaCost = e.target.value; field.onChange(e.checked) }} />
                        </React.Fragment>
                    )
                }
                }
            />
        );
    }

    const workCenterIdEditor = (options: any) => {
        return (
            <Controller
                name="workCenterIdEdit"
                control={formEditCE.control}
                defaultValue={options.value}
                rules={{
                    required: 'Work Center Id is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValueCE.workCenterId = field.value;

                    return (
                        <>
                            <Dropdown value={fieldState.isDirty ? field.value : options.value} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} options={workCenters} optionLabel="code" optionValue="id" className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.value); }} placeholder="Factory ID" />
                        </>
                    )
                }
                }
            />
        );
    }

    const rowEditorTemplate = (rowData: CostElement, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNewCE.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEditCE.getFieldState("descriptionEdit").invalid && !formEditCE.getFieldState("workCenterIdEdit").invalid) {
                            let _singleValue = { ...singleValueCE };
                            _singleValue.id = rowData.id;
                            _singleValue.description = itDescription.current.value;
                            _singleValue.allowFixedCost = chkAllowFixedCost.current.props.checked;
                            _singleValue.allowFormulaCost = chkAllowFormulaCost.current.props.checked;
                            save(_singleValue);
                            formEditCE.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEditCE.clearErrors();
                        formEditCE.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                !rowData.isUsed
                ?
                    <>
                        <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteCE(rowData)} to={''}></Link>
                    </>
                : <></>
            );
        }
    }

    const hideDeleteDialogCE = () => {
        setDeleteDialogCE(false);
    };

    const confirmDeleteCE = (value: CostElement) => {
        setSingleValueCE(value);
        setDeleteDialogCE(true);
    }

    const deleteRow = () => {
        let _listValues = listValuesCE.filter((val) => val.id !== singleValueCE.id);
        BomCostingService.deleteCostElement(singleValueCE.id).then((data: boolean) => {
            if (data) {
                setListValuesCE(_listValues);
                setDeleteDialogCE(false);
                setSingleValueCE(emptyCE);
                toastCE.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
            } else {
                toastCE.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
            }
        });

    };

    const deleteDialogFooterCE = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialogCE} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toastCE} />

            <Panel header="Add Cost Element" className="addPanel mb-2 -ml-2">
                <form onSubmit={formCE.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="description"
                                control={formCE.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    validate: {
                                        unique: v => listValuesCE.filter(val => val.description.toLowerCase() === v.toLowerCase()).length === 0 || 'Description must be unique.'
                                    } 
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={50} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('description')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="allowFixedCost"
                                control={formCE.control}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Fixed Cost</label><br />
                                        <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="allowFormulaCost"
                                control={formCE.control}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Formula Cost</label><br />
                                        <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="workCenterId"
                                control={formCE.control}
                                rules={{
                                    required: 'Work Center is required.'
                                }}
                                render={({ field, fieldState }) => (

                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Work Center ID</label>
                                        <Dropdown value={field.value} options={workCenters} optionLabel="code" optionValue="id" showClear className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.value); }} placeholder="Work Center ID" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{workCenters.find(ce => ce.id === field.value)?.description}</small> : <></>}
                                        {getErrorMessage('workCenterId')}
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable className="-ml-2" value={listValuesCE} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="id" size="small" rowHover={true} loading={loadingCE}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRowsCE} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                globalFilter={globalFilterCE} emptyMessage="No cost element records found." header={header}>
                <Column field="description" header="Description" sortable body={NameBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="allowFixedCost" header="Fixed Cost" sortable body={FixedCostBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="allowFormulaCost" header="Formula Cost" sortable body={FormulaCostBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="workCenterId" header="Work Center Id" sortable body={WorkCenterIdBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialogCE} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooterCE} onHide={hideDeleteDialogCE}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValueCE && (
                        <span>
                            Are you sure you want to delete <b>{singleValueCE.description}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}